import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <>
      <h2>Tahle stránka neexistuje</h2>
      <p className="text-body-secondary">Odkaz je možná starý. <Link to="/">Zpět na Moje práce</Link></p>
    </>
  );
}
